import AuthWrapper, { AuthWrapperProps } from './authWrapper';

/**
 * 不设置路由跳转的权限控制顶层组件
 * @param props
 * @returns
 */
export const AuthGrid = (props: AuthWrapperProps) => <AuthWrapper {...props} />;
